/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { Loader, RootState, TestTypesResponse } from 'src/store/types';

export const getTestTypesLoader = (state: RootState): Loader =>
  state.testTypeListing.loader;
export const getTestTypes = (state: RootState): TestTypesResponse =>
  state.testTypeListing.testTypes;
